// extracted by mini-css-extract-plugin
export default {"form":"PartnersForm_form__Jo1FW","button":"PartnersForm_button__DeDxw","formGroup":"PartnersForm_formGroup__UoAsU","editor":"PartnersForm_editor__CMbZq"};